// The whole file is copied from VPC
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { DataQualityAssetType, WarningStatusIcon } from '@tableau/data-catalog-client-components';
import { SiteUrls } from '@tableau/shared-urls';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { AppUrls } from '../../../../app/AppUrls';
import { ContentType } from '../../../models/ContentType';
import { IDataQualityIndicator } from '../../../models/httpClient/MetaDataResults';
import { VirtualConnection } from '../../../models/SearchResultTypes';
import { dataQualityOwnerToTableauUser, IDataQualityIndicatorDefinedInVizportalWebclientApi } from './CertificationCell';

export const CERTIFIED_INDICATOR_TYPE = 'CERTIFIED';

function contentTypeToAssetType(contentType: ContentType): DataQualityAssetType | null {
  switch (contentType) {
    /* case ContentType.datasource:
      return 'PublishedDatasource';
    case ContentType.flow:
      return 'Flow';
    case ContentType.database:
      return 'DatabaseServer';
    case ContentType.table:
      return 'DatabaseTable'; */
    case ContentType.virtualconnection:
      return 'VirtualConnection';
    default:
      return null;
  }
}

// Create an appropriate URL for a particular content type.
function urlForContentType(appUrls: AppUrls, contentType: ContentType, id: string): string {
  switch (contentType) {
    /* case ContentType.datasource:
      return appUrls.datasourceUrl(id);
    case ContentType.flow:
      return appUrls.flowUrl(id);
    case ContentType.database:
      return appUrls.catalogDatabaseUrl(id);
    case ContentType.table:
      return appUrls.catalogTableUrl(id); */
    case ContentType.virtualconnection:
      return appUrls.virtualConnectionUrl(id);
    default:
      return '';
  }
}

export function DataQualityWarningCell(
  siteUrls: SiteUrls,
  hasDataQualityIndicator: (row: DataGrid.Row) => boolean
): React.Factory<BodyCell.Props> {
  return React.createFactory(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    class DataQualityWarningCell extends React.Component<BodyCell.Props, any> {
      render() {
        if (!hasDataQualityIndicator(this.props.row)) {
          return null;
        }

        const contentTypeWithDQW = this.props.row.data as VirtualConnection;
        const assetUrl = urlForContentType(siteUrls, contentTypeWithDQW.contentType, contentTypeWithDQW.id);
        const assetType = contentTypeToAssetType(contentTypeWithDQW.contentType);

        const anchoredWarnings = contentTypeWithDQW.dataQualityIndicators?.filter((t) => t.type !== CERTIFIED_INDICATOR_TYPE);
        return (
          <span className="tb-quality-indicator-cell" style={{ width: 'auto' }} data-tb-test-id="DataQualityIndicatorCell">
            <WarningStatusIcon
              iconOnly={true}
              urls={siteUrls}
              kind={'vizportal'}
              upstreamWarnings={[]}
              subjectArea={assetType}
              anchoredAsset={{
                assetName: contentTypeWithDQW.name,
                assetType: assetType,
                assetUrl: (_) => assetUrl,
              }}
              anchoredWarnings={anchoredWarnings?.map((i) => dataQualityIndicatorInfoToDataQualityIndicator(i)) || []}
            />
          </span>
        );
      }
    }
  );
}

function dataQualityIndicatorInfoToDataQualityIndicator(
  indicator: IDataQualityIndicator
): IDataQualityIndicatorDefinedInVizportalWebclientApi {
  const { owner, ...rest } = indicator;
  const user = dataQualityOwnerToTableauUser(owner);

  return {
    ...rest,
    updatedAt: new Date(indicator.updatedAt),
    owner: {
      domain: user.domain!,
      domainName: user.domain!,
      username: user.username!,
      displayName: user.name!,
      authId: '',
      id: '',
    },
  };
}
